<template>
  <div v-if="bannerText" :class="[clickable ? 'cursor-pointer' : '', 'w-full py-4 px-4 relative']"
    :style="{ backgroundColor: backgroundColor }" @click="handleClick">
    <div class="max-w-7xl mx-auto">
      <div class="flex items-center justify-between">
        <div class="flex-1 text-center">
          <p class="font-marketing font-medium text-lg" :style="{ color: textColor }" v-html="renderedText"></p>
          <p v-if="bannerSubtext" class="font-sans text-sm mt-1" :style="{ color: textColor }" v-html="renderedSubtext">
          </p>
        </div>
        <button v-if="dismissible" @click.stop="$emit('dismiss')" class="ml-4 hover:opacity-70 transition-opacity"
          :style="{ color: textColor }" aria-label="Dismiss banner">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  bannerText: {
    type: String,
    default: 'Special Offer: 20% off all books this month!'
  },
  bannerSubtext: {
    type: String,
    default: ''
  },
  dismissible: {
    type: Boolean,
    default: true
  },
  backgroundColor: {
    type: String,
    default: '#FEF3C7'
  },
  textColor: {
    type: String,
    default: '#111111'
  },
  links: {
    type: Array,
    default: () => []
  },
  clickable: {
    type: Boolean,
    default: false
  },
  scrollTo: {
    type: String,
    default: ''
  },
  index: {
    type: Number,
    default: 0
  }
})

const renderTextWithLinks = (text, links) => {
  if (!text || !links || links.length === 0) {
    return text
  }

  let result = text
  const sortedLinks = [...links].sort((a, b) => b.start_index - a.start_index)

  for (const link of sortedLinks) {
    const before = result.substring(0, link.start_index)
    const linkText = result.substring(link.start_index, link.end_index)
    const after = result.substring(link.end_index)
    result = before + `<a href="${link.url}" target="_blank" rel="noopener noreferrer" class="link-blue">${linkText}</a>` + after
  }

  return result
}

const renderedText = computed(() => renderTextWithLinks(props.bannerText, props.links))
const renderedSubtext = computed(() => props.bannerSubtext || '')

defineEmits(['dismiss'])

const handleClick = () => {
  if (props.clickable && props.scrollTo) {
    const element = document.getElementById(props.scrollTo)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}
</script>

<style scoped>
:deep(.link-blue) {
  color: #2563eb;
  text-decoration: underline;
  transition: color 0.2s;
  font-family: inherit;
}

:deep(.link-blue):hover {
  color: #1e40af;
}

:deep(.link-blue):visited {
  color: #2563eb;
}
</style>
